import { render, staticRenderFns } from "./Coming.vue?vue&type=template&id=fad99e32&scoped=true"
import script from "./Coming.vue?vue&type=script&lang=js"
export * from "./Coming.vue?vue&type=script&lang=js"
import style0 from "./Coming.vue?vue&type=style&index=0&id=fad99e32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad99e32",
  null
  
)

export default component.exports